import { LoaderFunctionArgs } from "react-router-dom";
import { wrappedCollectionFetcher } from "services/api.service";

export const loader = async ({ request }: LoaderFunctionArgs) => {
  const url = new URL(request.url);
  const query = url.searchParams.get("q");
  const response = await wrappedCollectionFetcher(
    `/product_catalogs?filter[]=merchant_product_number,contains,${query}&page[size]=10`,
  );
  return response;
};
